
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getBankSubbranchList } from '@/api/ccx'

@Component
export default class bankBranchPopup extends Vue {
  @Prop({ default: '' }) title?: string

  popShow = false
  columns = []

  showPop(params) {
    this.popShow = true
    this.getBankSubbranchList(params)
  }

  getBankSubbranchList(params) {
    getBankSubbranchList(params).then((res) => {
      this.columns = res.data.records
    })
  }

  onCancel() {
    this.popShow = false
  }

  onConfirm(val: any) {
    const { bankSubbranchName } = val
    this.popShow = false
    this.$emit('confirm', bankSubbranchName)
  }
}
